import ReactGA from "react-ga4";

// const MAX_CHARACTERISTICS = 40;

/**
 * Initializes Google Analytics with the provided tracking ID.
 */
export const initGA = () => {
  ReactGA.initialize(`${process.env.REACT_APP_GA_TRACKING_ID}`);
};

/**
 * Logs a page view to Google Analytics.
 * 
 * @param {string} [title=''] - The title of the page. Optional.
 */
export const logPageView = (title = '') => {
  const pageViewData = { hitType: 'pageview', page: window.location.pathname };
  if (title) {
    pageViewData.title = title+' visit';
  }
  ReactGA.send(pageViewData);
};

/**
 * Logs an event to Google Analytics.
 * 
 * @param {string} category - The category of the event.
 * @param {string} action - The action of the event.
 * @param {string} [label=''] - The label of the event. Optional.
 */
export const logEvent = (category = "", action = "", label = "") => {
  // const characteristics = [category, action, label].filter(Boolean);
  // if (characteristics.length > MAX_CHARACTERISTICS) {
  //   console.warn(`Too many characteristics: ${characteristics.length}. Maximum allowed is ${MAX_CHARACTERISTICS}.`);
  //   ReactGA.event({category:"error", action:"too many characteristics", label:characteristics.length});
  //   return;
  // }
  if (category && action) {
    ReactGA.event({ category, action, label });
  }
};

/**
 * Logs a conversion event to Google Analytics.
 * 
 * @param {string} category - The category of the event.
 * @param {string} action - The action of the event.
 * @param {string} label - The label of the event.
 */
export const logConversion = (category = "", action = "", label = "") => {
  // const characteristics = [category, action, label].filter(Boolean);
  // if (characteristics.length > MAX_CHARACTERISTICS) {
  //   console.warn(`Too many characteristics: ${characteristics.length}. Maximum allowed is ${MAX_CHARACTERISTICS}.`);
  // ReactGA.event({category:"error", action:"too many characteristics", label:characteristics.length});
  //   return;
  // }
  if (category && action && label) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};